import { useState } from "react";

import { Popover, PopoverContent, PopoverTrigger } from "@monorepo-apps/ui/src/components/popover";

import { MatrixCellPicker } from "@/presentation/components/coverage-matrix/matrix-cell-picker";
import type { FeatureProductCoverage } from "@/infrastructure/supabase/database.types";

interface MatrixCellProps {
  coverage: FeatureProductCoverage | null;
  onPick: (next: FeatureProductCoverage | null) => void;
}

const STYLE: Record<FeatureProductCoverage, { label: string; bg: string; color: string }> = {
  native: { label: "N", bg: "oklch(0.93 0.07 145)", color: "oklch(0.35 0.16 145)" },
  plugin: { label: "P", bg: "oklch(0.93 0.06 260)", color: "oklch(0.35 0.16 260)" },
  custom: { label: "C", bg: "oklch(0.93 0.09 50)", color: "oklch(0.40 0.16 50)" },
  irrelevant: { label: "—", bg: "oklch(0.96 0.005 240)", color: "oklch(0.55 0.01 240)" },
};

export function MatrixCell({ coverage, onPick }: MatrixCellProps) {
  const [open, setOpen] = useState(false);
  const s = coverage ? STYLE[coverage] : null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="font-data flex h-7 w-full items-center justify-center rounded border text-[11px] font-semibold tabular-nums transition-colors"
          style={
            s
              ? { borderColor: s.color, background: s.bg, color: s.color }
              : {
                  borderColor: "oklch(0.94 0.005 240)",
                  background: "white",
                  color: "oklch(0.78 0.01 240)",
                }
          }
          aria-label={`Coverage: ${coverage ?? "not assessed"}`}
        >
          {s ? s.label : "·"}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-44 p-0" align="center" sideOffset={6}>
        <MatrixCellPicker current={coverage} onPick={onPick} onClose={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
}
